import { useState, useEffect } from 'react';
import { logoUrl } from '@/mocks/homeData';

const navItems = [
  { label: '천안GF골프연습장', href: '#top' },
  { label: '레슨소개', href: '#lesson' },
  { label: '소속프로소개', href: '#pro' },
  { label: '오시는길', href: '#company' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMobileOpen(false);
    }
  };

  return null;
}